@if (store) {
<div class=" b-radius-4 p-a-2 _item"
     [ngClass]="{'selected' : 'bg-col-61 b-col-6', 'disabled' : 'b-col-51 bg-col-51', 'default' : 'bg-col-51'}[storeStatus]">
    <div class="flex flex-justify-between">
        <p class="s1 col-1"
           [class.col-4]="storeStatus === 'disabled'">{{store.data?.store_name}}</p>
        @if(hasQty) {
        @if(stockQty > 0){
        <p class="s2 col-3">{{stockQty}}&nbsp;{{'Available' | translate}}</p>
        } @else {
        <p class="s2 col-3">{{(stockMessage ? stockMessage : 'In stock') | translate}}</p>
        }
        }
    </div>
    <p [ngClass]="storeStatus === 'disabled' ? 'col-4' : 'col-11'"
       class="p2 m-t-3">{{store.data?.address}},</p>
    <p class="c1 m-t-3"
       [ngClass]="storeStatus === 'disabled' ? 'col-4' : 'col-11'">{{store.data?.email}}</p>
    <p class="c1"
       [ngClass]="storeStatus === 'disabled' ? 'col-4' : 'col-11'">{{store.data?.phone}}</p>
    <div class="flex flex-justify-between m-t-3">
        <button [inlineButton]
                [class.hidden]="storeStatus === 'disabled' || storeStatus === 'selected'">
            <p class="s2">{{'Select branch' | translate}}</p>
        </button>
        @if(hasDistance){
        <p class="c2"
           [class.col-4]="storeStatus === 'disabled'">{{ '% miles away' | translate : distance.toFixed(1) }}</p>
        }
    </div>
</div>
}
